import { Phone, ChatText } from "@phosphor-icons/react";

export const StickyCallBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-line bg-asphalt sm:hidden"
    data-testid="sticky-call-bar"
  >
    <div className="grid grid-cols-2 pr-[92px]">
    <a
      href="tel:+19053517489"
      data-testid="sticky-call-button"
      className="flex min-h-[60px] items-center justify-center gap-2 bg-safety font-display text-base font-bold uppercase tracking-wide text-asphalt active:bg-safetydeep"
    >
      <Phone weight="bold" className="h-5 w-5" aria-hidden="true" />
      Call
    </a>
    <a
      href="sms:+19053517489"
      data-testid="sticky-text-button"
      className="flex min-h-[60px] items-center justify-center gap-2 bg-asphalt font-display text-base font-bold uppercase tracking-wide text-safety active:bg-surface"
    >
      <ChatText weight="bold" className="h-5 w-5" aria-hidden="true" />
      Text
    </a>
    </div>
  </div>
);
